import { HostListener, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AjaxObservableService } from '../services/ajax-observable.service';
import { UserDetailsService } from '../services/user-details.service';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import { takeUntil, filter } from "rxjs/operators";
import { Subject } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class FreshchatService {
  isUserLoggedIn = false;
  isVipUser = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  userProfile = {};
  authRetryCount = 0;
  maxRetries = 3;

  //host = environment.freshChatConfig.host;
  scriptPath = environment.freshChatConfig.scriptPath;
  //token = environment.freshChatConfig.token;
  widgetId = environment.freshChatConfig.widgetId;

  constructor(
    private ajaxObservableService: AjaxObservableService,
    private userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    private utils: Utility,
    private userService: UserDetailsService
  ) {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = loginStatus;

      if (this.isUserLoggedIn) {
          let snippetEleRef = document.getElementById("fc-snippet");
          if(snippetEleRef){
            this.initChat()
          }
      }
      // this.showChatBox();
    });
   
  }
  initChat(){
    // var script = document.createElement('script');
    // script.src = 'https://eu.fw-cdn.com/12512065/556764.js'; // Replace this placeholder string from your account. Go to Admin Settings > Chat Widget Customization > Web (Embed Code)
    // script.setAttribute('chat', 'false');
    // // script.setAttribute('widgetId', '4f9429d4-94c0-4126-8eb1-26129bfc1d76');
    // document.body.appendChild(script);

    let snippetEleRef = document.getElementById("fc-snippet");

    //check if the script was already loaded.
    if (snippetEleRef) {
       this.showChatBox();
    }
    var freshChatScript = document.createElement("script");
    freshChatScript.id = "fc-snippet";
    freshChatScript.src = this.scriptPath //"https://eu.fw-cdn.com/12512065/556764.js";//this.zendeskScriptPath;
    freshChatScript.setAttribute('chat', 'false');
    freshChatScript.setAttribute('widgetId', this.widgetId);
    document.head.appendChild(freshChatScript);

    //the rest of the script needs to run after the script has loaded.
    document.getElementById("fc-snippet").addEventListener("load",  () => {
      setTimeout(() => {
        this.showChatBox();
      }, 1000);
    });

    if(this.isUserLoggedIn){
      setTimeout(() => {
        // console.log("121212121");
      let userProfile = this.userDetailsService.getUserProfileDetails();
     
        // window["fcWidget"].setExternalId(userProfile.externalEcrId);
        if(window["fcWidget"]){
          window["fcWidget"].user.setFirstName(userProfile.firstName);
          window["fcWidget"].user.setLastName(userProfile.lastName);
          window["fcWidget"].user.setEmail(userProfile.emailId);
        }
      },2000);
    }
  }


  showChatBox(){
    if (window["fcWidget"].isOpen() != true) {
      window["fcWidget"].open();
      //Or do something else :)
    } else {
      window["fcWidget"].close();
    }
  }
 
}
